/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for CompanyResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetCompanyByIdResponse, CustomerState, GetCompaniesResponse } from "../models";

@Injectable({ providedIn: "root" })
export class CompanyResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getCompanyById(id: Signal<number> | number, resourceOptions: HttpResourceOptions<GetCompanyByIdResponse, unknown> & { defaultValue: NoInfer<GetCompanyByIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCompanyByIdResponse>;
    getCompanyById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetCompanyByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCompanyByIdResponse | undefined>;
    getCompanyById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetCompanyByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCompanyByIdResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Company/${typeof id === 'function' ? id() : id}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getCompanies(searchTerm: Signal<string | null | undefined> | string | null | undefined, states: Signal<(Array<CustomerState> | null) | undefined> | (Array<CustomerState> | null) | undefined, resourceOptions: HttpResourceOptions<GetCompaniesResponse, unknown> & { defaultValue: NoInfer<GetCompaniesResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCompaniesResponse>;
    getCompanies(searchTerm?: Signal<string | null | undefined> | string | null, states?: Signal<(Array<CustomerState> | null) | undefined> | (Array<CustomerState> | null), resourceOptions?: HttpResourceOptions<GetCompaniesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCompaniesResponse | undefined>;
    getCompanies(searchTerm?: Signal<string | null | undefined> | string | null, states?: Signal<(Array<CustomerState> | null) | undefined> | (Array<CustomerState> | null), resourceOptions?: HttpResourceOptions<GetCompaniesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCompaniesResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const searchTermValue = typeof searchTerm === 'function' ? searchTerm() : searchTerm;
            if (searchTermValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, searchTermValue, 'searchTerm');
            }
            const statesValue = typeof states === 'function' ? states() : states;
            if (statesValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, statesValue, 'states');
            }
            return {
                url: `${this.basePath}/Company`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
